import { parseMacroGruppi } from "./parseMacroGruppi";
import { parseOutrightsData } from "./parseOutrightsData";
import { getConfiguration } from './utils/configuration';
import { filterByCustomizedState } from './utils/filterByCustomizedState';
import { getDBTimestampFromDate } from './utils/getDBTimestampFromDate';
import { getLocaleTimestamp } from './utils/getLocaleTimestamp';
import { groupEventsByDate } from './utils/groupEventsByDate';
import { parseTournamentEvents } from "./utils/parseTournamentEvents";

export function parseBetBuilderEvents(data, tournamentData, tournamentId) {
    const conf = getConfiguration();
    // Filter expired events
    let events = tournamentData.avs.filter(avv => {
        const matchTimestamp = conf.dbutc ? getLocaleTimestamp(avv.ts) : avv.ts;
        const currentTimestamp = getDBTimestampFromDate(new Date());
        return matchTimestamp.localeCompare(currentTimestamp) > 0;
    });
    events = filterByCustomizedState(events);
    const tournament = {
        // Recupera i dati del torneo
        ...data.tournamentByUniqueId[tournamentId],
        // Aggiungi gli eventi al torneo
        events
    };
    //const aggregate = tournamentData.ags;
    tournament.events = parseTournamentEvents(data, tournament, [], 0, false, false);

    // Aggiungi i macrogruppi, se esistono
    tournament.macrogruppi = tournament.events.length > 0 ? parseMacroGruppi(tournament.events[0].gruppoById, tournament.sportRef, false) : [];
    //Aggiungo classifica
    tournament.classifica = tournamentData.sid;
    tournament.outrights = tournamentData.ors ? parseOutrightsData(tournamentData.ors, tournament.sportRef,tournament.descrizione,data.sportById[tournament.sportRef].descrizione) : [];
	tournament.betbuilder = tournamentData.bb;
    [tournament.dates, tournament.matchesByDate] = groupEventsByDate(tournament.events);

    return tournament;
}
